module.exports = __webpack_public_path__ + "images/ea141b2ced2cffbc4e595a19fd93ab72-desk3.jpg";